module.exports = __webpack_public_path__ + "static/img/zz.e1320f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zz.png
// module id = 0da1
// module chunks = 1